import BigNumber from 'bignumber.js';
/* eslint-disable no-bitwise */
import { getFixed, getTimes, isGte, isLte, isNumber } from "@/utils/number";

// formatAmount
export const formatUsdt = (val) => getFixed(val, 8);

export const formatPrice = (val) => {
  let k = ''
  let v = val
  if (val >= 1e12) {
    v = (val / 1e12).toFixed(2)
    k = 'T';
  } else if (val >= 1e9) {
    v = (val / 1e9).toFixed(2)
    k = 'B';
  } else if (val >= 1e6) {
    v = (val / 1e6).toFixed(2)
    k = 'M';
  } else if (val >= 1000) {
    v = (val / 1000).toFixed(2)
    k = 'K';
  }

  if (isLte(v, 1) && isGte(v, -1)) {
    return formatNumber(getFixed(v, 6)) + k;
  }
  return formatNumber(getFixed(v, 4)) + k;
};

export const formatBalance = (val) => {
  if (!isNumber(val)) {
    return "--";
  }
  return getFixed(val, 6);
};

export const formatLongStr = (val, start = 6, end = 6, mid = "...") => {
  if (val.length > start + end) {
    return `${val.substr(0, start)}${mid}${val.substr(val.length - end, end)}`;
  }
  return val;
};

export const formatPercent = (val) => `${getTimes(val, 100)}%`;

export const formatDateLabel = (date, fmt) => {
  const o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };

  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));

  for (const k in o)
    if (new RegExp(`(${k})`).test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
      );
  return fmt;
};

export const formatDate = (date, format = 'YYYY-MM-DD hh:mm:ss') => {
  if (!(date instanceof Date)) {
    if (date < new Date('2025-01-01').getTime()) date = date * 1000
    date = new Date(date)
    // throw new Error("The first argument must be a Date object.");
  }

  const padZero = (num) => (num < 10 ? `0${num}` : num);

  const map = {
    YYYY: date.getFullYear(),
    MM: padZero(date.getMonth() + 1), // 月份从0开始，所以需要+1
    DD: padZero(date.getDate()),
    hh: padZero(date.getHours()),
    mm: padZero(date.getMinutes()),
    ss: padZero(date.getSeconds()),
  };

  return format.replace(/YYYY|MM|DD|hh|mm|ss/g, (match) => map[match]);
};

export function formatNumber (number, dec = 2, dsep, tsep) {
  if (number === 0) return 0;

  if (isNaN(+number) || number == null) return "";

  number = parseFloat(number);
  
  // number = number.toFixed(~~dec);
  number = (Math.floor((+number) * (10 ** (+dec))) / (10 ** (+dec))).toFixed(~~dec);

  tsep = typeof tsep === "string" ? tsep : ",";

  const parts = number.split(".");
  const fnums = parts[0];
  const decimals = parts[1] ? (dsep || ".") + parts[1] : "";

  return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, `$1${tsep}`) + decimals;
}

export function formatAccount (account) {
  return account && account.length > 10
    ? account.substring(0, 6) + "****" + account.substring(account.length - 4)
    : account;
}

export function formatHash (hash) {
  if (!hash) return "--";
  return hash.substring(0, 6) + "****" + hash.substring(hash.length - 6);
}

export const toFixed = function (val, decimal) {
  if (!val) return '';
  const result = new BigNumber(val).toFixed(decimal || 8);
  if (/\.0+$/.test(result)) {
    return result.replace(/\.0+$/gi, '');
  }
  return result.indexOf('.') > 0 ? result.replace(/0+$/gi, '') : result;
}

export default {
  install (Vue) {
    Vue.filter("formatNumber", formatNumber);
    Vue.filter("formatUsdt", formatUsdt);
    Vue.filter("formatPrice", formatPrice);
    Vue.filter("formatBalance", formatBalance);
    Vue.filter("formatLongStr", formatLongStr);
    Vue.filter("formatPercent", formatPercent);
    Vue.filter("formatDate", formatDate);
    Vue.filter("formatAccount", formatAccount);
    Vue.filter("formatHash", formatHash);
  },
};
